var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51144 12.4895C8.51099 12.2559 8.59236 12.0294 8.74144 11.8495L13.7414 5.84953C13.9112 5.64532 14.1551 5.51689 14.4195 5.49251C14.6839 5.46813 14.9472 5.54979 15.1514 5.71953C15.3557 5.88927 15.4841 6.13318 15.5085 6.39761C15.5328 6.66204 15.4512 6.92532 15.2814 7.12953L10.8014 12.4895L15.1214 17.8495C15.2045 17.9518 15.2665 18.0695 15.304 18.1959C15.3414 18.3222 15.3535 18.4547 15.3396 18.5857C15.3256 18.7167 15.2859 18.8437 15.2227 18.9594C15.1596 19.075 15.0742 19.177 14.9714 19.2595C14.8686 19.3511 14.748 19.4205 14.6171 19.4633C14.4862 19.5061 14.3479 19.5214 14.2109 19.5082C14.0738 19.4951 13.9409 19.4538 13.8206 19.3869C13.7002 19.32 13.595 19.229 13.5114 19.1195L8.68144 13.1195C8.55593 12.9344 8.49607 12.7126 8.51144 12.4895Z",
    fill: "#020209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.43188181832f79ce8c0daac8fdb7273e.svg";
export { ForwardRef as ReactComponent };